import { useEffect } from "react";
import { useLocation } from "react-router";
import { useEventTracking } from "../hooks/use-posthog";

/**
 * PostHog Page Tracking Component
 *
 * Automatically tracks page views when users navigate to different routes.
 * This is a common PostHog pattern for SPAs.
 */
export const PostHogPageTracking = () => {
  const location = useLocation();
  const { captureEvent } = useEventTracking();

  useEffect(() => {
    if (captureEvent) {
      console.log("PostHog: Page view tracked:", location.pathname);
      captureEvent("$pageview", {
        path: location.pathname,
        search: location.search,
        hash: location.hash,
        referrer: document.referrer,
        title: document.title,
      });
    }
  }, [location, captureEvent]);

  // This component doesn't render anything
  return null;
};
